
import {Component, Vue, Prop} from 'vue-property-decorator';
import * as echarts from 'echarts';
import moment from 'moment';
import EchartsTooltip from './EchartsTooltip.vue';
import {statisticsApi} from '@/api'; //ljx
import Empty from '@/components/Empty/index.vue';
const chartTooltip = Vue.extend(EchartsTooltip);
@Component({
    components: {
        Empty
    }
})
export default class LearningProgress extends Vue {
    schoolId = '';
    searchQuery: {course: string | undefined; time: string} = {
        time: 'month',
        course: undefined
    };
    courseList: {value?: string | undefined; label: string}[] = [];
    classList = [];
    selectClassListId: string[] = [];
    chart = {};
    option = {};

    progress = [0, 20, 40, 60, 80, 100];
    XAixs: {}[] = [];
    week = [];
    initChart() {
        const chartDom: HTMLElement | null = document.querySelector('#chartBox');
        if (chartDom) {
            this.chart = echarts.init(chartDom, undefined, {renderer: 'svg'});
            this.option = {
                tooltip: {
                    position: function (
                        point: number[],
                        e: any,
                        dom: {
                            parentNode: {getBoundingClientRect: () => {(): any; new (): any; top: number; left: any}};
                            style: {position: string};
                            clientWidth: number;
                            clientHeight: number;
                        },
                        size: any
                    ) {
                        var left = dom.parentNode.getBoundingClientRect().left;
                        var result = point[0] + left + dom.clientWidth > document.body.clientWidth ? 'left' : 'right';
                        return result;
                    },
                    // confine: true,
                    borderColor: '#EBEDF0',
                    padding: [16, 8, 16, 16],
                    enterable: true,
                    formatter: (params: any) => {
                        const com = new chartTooltip() as EchartsTooltip;
                        com.setData({...params, dateType: this.formatDateType, tooltipsType: 'learningProgress'});
                        com.$mount();
                        return com.$el.innerHTML;
                    }
                },
                grid: {
                    left: 0,
                    bottom: 16,
                    right: 24,
                    top: 32,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: this.XAixs,
                    boundaryGap: false,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#EBEDF0'
                        }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#EBEDF0'
                        }
                    },
                    axisTick: {
                        show: true
                    },
                    axisLabel: {
                        show: true,
                        color: 'rgba(0,0,0,0.6)',
                        margin: 24,
                        formatter: (value: string) => {
                            if (this.formatDateType === 'day') {
                                return `${moment(value).date()}日`;
                            } else {
                                return moment(value).format('YYYY.MM');
                            }
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    interval: 20,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#EBEDF0'
                        }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#EBEDF0'
                        }
                    },
                    axisTick: {
                        show: true
                    },
                    axisLabel: {
                        show: true,
                        color: 'rgba(0,0,0,0.6)',
                        margin: 24,
                        formatter: function (value: number) {
                            return `${value}%`;
                        }
                    }
                },
                series: [
                    {
                        name: 'Punch Card',
                        type: 'scatter',
                        symbolSize: function (val: number[]) {
                            return val[2] > 50 ? 53 : val[2] + 3;
                        },
                        data: this.progressData,
                        animationDelay: function (idx: number) {
                            return idx * 5;
                        },
                        itemStyle: {
                            color: '#4B77E9'
                        }
                    }
                ]
            };
            (this.chart as any).setOption(this.option);
            window.addEventListener('resize', () => {
                (this.chart as any).resize();
            });
            (this.chart as any).on('mouseover', (params: any) => {
                if (params.value[3].classList.length) {
                    this.selectClassListId = params.value[3].classList.map((item: any) => item.classId);
                }
            });
            (this.chart as any).on('mouseout', (params: any) => {
                this.selectClassListId = [];
            });
        }
    }
    onChange(val?: any) {
        if (val.target.value === 'year') {
            this.XAixs = this.getMonths(12);
        } else if (val.target.value === 'month') {
            this.XAixs = this.getDays(30);
        } else if (val.target.value === 'halfYear') {
            this.XAixs = this.getMonths(6);
        } else {
            this.XAixs = this.getDays(7);
        }

        if (this.searchQuery.course) {
            this.getCourseClass();
        } else {
            this.progressData = [];
            this.classList = [];
            setTimeout(() => {
                this.initChart();
            });
        }
    }

    getDays(day: number) {
        const dates = [];
        const NUM_OF_DAYS = day;

        this.formatDateType = 'day';
        this.fromDate = moment()
            .subtract(day - 1, 'day')
            .format('YYYY-MM-DD 00:00:00');
        for (let i = 0; i < NUM_OF_DAYS; i++) {
            const date = moment().subtract(i, 'day').format('YYYY-MM-DD');
            dates.push({value: date});
        }
        return dates.reverse();
    }
    getMonths(month: number) {
        const dates = [];
        const NUM_OF_MONTHS = month;

        this.formatDateType = 'month';
        this.fromDate = moment()
            .subtract(month - 1, 'month')
            .format('YYYY-MM-DD 00:00:00');

        for (let i = 0; i < NUM_OF_MONTHS; i++) {
            const date = moment().subtract(i, 'month').format('YYYY-MM');
            dates.push({value: date});
        }
        return dates.reverse();
    }

    progressData: any[] = [];
    getLearningProgress() {
        const urlQueryParmas = {
            startTime: this.fromDate,
            endTime: moment().format('YYYY-MM-DD 24:00:00'),
            unit: this.formatDateType,
            schoolId: this.schoolId,
            courseId: this.searchQuery.course
        };
        statisticsApi.getLearningProgress({
            context: this,
            urlQueryParmas,
            success: (data: any) => {
                if (data.code === 0) {
                    if (data.data.plans && data.data.plans.length) {
                        const tempData = data.data.plans.map(
                            (item: {
                                latestOverTime: moment.MomentInput;
                                donePlan: number;
                                beginClassQuantity: number;
                                classId: string;
                                className: string;
                            }) => {
                                return {
                                    beginClassQuantity: item.beginClassQuantity,
                                    classId: item.classId,
                                    className: item.className,
                                    originDonePlan: item.donePlan || 0,
                                    donePlan: this.formatProgress(item.donePlan || 0),
                                    latestOverTime: moment(item.latestOverTime).format(
                                        this.formatDateType === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM'
                                    ),
                                    count: 1,
                                    classList: []
                                };
                            }
                        );
                        this.formatData(tempData);
                    } else {
                        this.progressData = [];
                    }
                    this.$nextTick(() => {
                        this.initChart();
                    });
                }
            }
        });
    }

    formatProgress(progress: number) {
        let result = progress;
        if (progress > 0 && progress < 20) {
            result = 10;
        } else if (progress >= 20 && progress < 40) {
            result = 30;
        } else if (progress >= 40 && progress < 60) {
            result = 50;
        } else if (progress >= 60 && progress < 80) {
            result = 70;
        } else if (progress >= 80 && progress < 100) {
            result = 90;
        }
        return result;
    }
    formatData(data: any[]) {
        var result = [];
        var flag = true;
        result.push(data[0]);
        for (var i = 1; i < data.length; i++) {
            flag = true;
            for (var j = 0; j < result.length; j++) {
                if (data[i].latestOverTime == result[j].latestOverTime && data[i].donePlan == result[j].donePlan) {
                    flag = false;
                    result[j].count = data[i].count + result[j].count;
                    result[j].classList.push(data[i]);
                }
            }
            if (flag) result.push(data[i]);
        }
        this.progressData = result.map(item => {
            const classList = item.classList.concat(item);
            return [item.latestOverTime, item.donePlan, item.count, {classList}];
        });
    }
    getCourse(schoolId: string) {
        this.searchQuery.course = undefined;
        statisticsApi.getSchoolDistributionCourse({
            context: this,
            urlQueryParmas: {schoolId},
            success: (data: any, parameters: any) => {
                if (data.code === 0) {
                    this.courseList = data.data
                        .map((item: {[x: string]: any; course: {name: string}; courseId: string}, index: any) => {
                            return {
                                label: item.course.name,
                                value: item.courseId,
                                date: new Date(item.date).getTime()
                            };
                        })
                        .sort((a: {date: number}, b: {date: number}) => {
                            return b.date - a.date;
                        });
                    if (this.courseList.length) {
                        this.searchQuery.course = this.courseList[0].value;
                        this.getCourseClass();
                    } else {
                        this.progressData = [];
                        this.classList = [];
                        setTimeout(() => {
                            this.initChart();
                        });
                    }
                }
            },
            error: (error: any, message: string, parameters: any) => {
                this.$message.error(message);
            }
        });
    }

    fromDate = '';
    formatDateType = 'day';
    getCourseClass() {
        const urlQueryParmas = {
            to: '',
            from: ''
        };
        statisticsApi.getAuthorizeCourseList({
            context: this,
            urlQueryParmas: urlQueryParmas,
            courseId: this.searchQuery.course,
            success: (data: any, parameters: any) => {
                if (data.code === 0) {
                    if (data.data.length) {
                        const schoolList = data.data.filter((item: {schoolId: string}) => item.schoolId === this.schoolId);
                        if (schoolList.length) {
                            this.classList = schoolList[0].associatedClass;
                        } else {
                            this.classList = [];
                        }
                    } else {
                        this.classList = [];
                    }
                    this.getLearningProgress();
                }
            },
            error: (error: any, message: string, parameters: any) => {
                this.$message.error(message);
            }
        });
    }
    getData() {
        this.getCourseClass();
    }
    mounted() {
        const value = window.localStorage.getItem('aicp_school_materials_$state_aicp_school_materials');
        this.schoolId = JSON.parse(value as string).schoolId;
        this.getCourse(this.schoolId);
        this.onChange({target: {value: 'month'}});
    }
}
